export const PRIMA_WEBSITE_URL = 'https://www.prima.com.pe';
export const VIRTUAL_AGENCY_URL = 'https://miespacio.prima.com.pe';

const PUBLIC_ZONE_URL = `${PRIMA_WEBSITE_URL}/public-zone`;
export const PRIVACY_POLICY_URL = `${PUBLIC_ZONE_URL}/sobre-prima-afp/politica-de-privacidad`;
export const GOAL_COUNTS_URL = `${PUBLIC_ZONE_URL}/files/2023/pdf/Cuenta_Metas.pdf`;